import classNames from 'classnames';
import React, {useState} from 'react';

import {useI18n} from '@udemy/i18n';
import {AdvertisingBanner} from '@udemy/react-messaging-components';

import {PersonalPlanBannerModal} from './personal-plan-banner-modal.react-component';
import styles from './personal-plan-banner.module.less';

interface PersonalPlanBannerProps {
    isPaidSubscriber: boolean;
    className?: string;
}

export const PersonalPlanBanner: React.FC<PersonalPlanBannerProps> = ({
    isPaidSubscriber,
    className,
}) => {
    const {gettext} = useI18n();
    const [isModalOpen, setIsModalOpen] = useState(false);

    if (isPaidSubscriber) {
        return null;
    }

    const handleLearnMoreClick = () => {
        setIsModalOpen(true);
    };

    const handleCloseModal = () => {
        setIsModalOpen(false);
    };

    return (
        <div className={className}>
            <AdvertisingBanner
                className={classNames(styles.banner)}
                background="light"
                title={gettext('Udemy Personal Plan')}
                titleClassName="ud-heading-lg"
                subtitle={gettext(
                    'Our collection of 13,000+ top-rated courses, curated to help you stay one step ahead',
                )}
                subtitleClassName={classNames(styles.subtitle, 'ud-text-sm')}
                submitButtonText={gettext('Learn more')}
                submitButtonProps={{
                    udStyle: 'ghost',
                    typography: 'ud-text-sm',
                    className: 'ud-link-underline',
                    componentClass: 'a',
                    onClick: handleLearnMoreClick,
                    size: 'small',
                }}
            />
            <PersonalPlanBannerModal isOpen={isModalOpen} onClose={handleCloseModal} />
        </div>
    );
};
